import React from "react";
import "./Services.css";

function Services() {
  const services = [
    {
      title: "Frontend Development",
      description:
        "Building responsive and interactive web interfaces using React.js, JavaScript, HTML, CSS, and modern UI frameworks.",
    },
    {
      title: "Full-Stack Development",
      description:
        "Developing complete web applications with React.js, Node.js, Express.js, and MongoDB, from user interfaces to backend APIs.",
    },
    {
      title: "Responsive Web Design",
      description:
        "Creating websites that provide a smooth and consistent experience across desktops, tablets, and mobile devices.",
    },
    {
      title: "UI/UX Implementation",
      description:
        "Turning designs and ideas into clean, user-friendly interfaces with a strong focus on usability and visual consistency.",
    },
    {
      title: "React Web Applications",
      description:
        "Developing dynamic web applications with React, reusable components, React Router, and API integration.",
    },
    {
      title: "API Integration",
      description:
        "Connecting frontend applications with REST APIs to fetch, manage, and display dynamic data efficiently.",
    },
    {
      title: "Website Optimization",
      description:
        "Improving website performance, responsiveness, code structure, and overall user experience.",
    },
  ];

  return (
    <section id="services" className="services-section py-5">
      <div className="container">
        <h2 className="text-center mb-4">Services</h2>
        <div className="row">
          {services.map((service) => (
            <div key={service.title} className="col-md-4 mb-3">
              <div className="service-card h-100">
                <h3>{service.title}</h3>
                <p>{service.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Services;
